<div>
  <div tiimeIconProperty>
    <mat-icon svgIcon="icon-contrats"></mat-icon>
    <span>Contrats :</span>
    @if (!contracts()) {
      <mat-progress-spinner class="loader" diameter="15" color="primary" mode="indeterminate"></mat-progress-spinner>
    }
  </div>
  <tiime-list>
    @for (contract of contracts(); track contract.id) {
      <tiime-list-item small (click)="emitUpdateContract(contract)">
        <mat-icon
          class="business-unit-icon"
          svgIcon="icon-group"
          tiimeTooltip="Groupe: {{ contract.businessUnit?.name }}"
          tiimeListItemIcon
        ></mat-icon>
        <app-contract-status-select
          label=""
          [small]="true"
          [contractId]="contract.id"
          [contractStatus]="contract.status"
          [contractStatusAt]="contract.statusAt"
          [contractStatusBy]="contract.statusBy"
          [statusDisabled]="updateStatusDisabled() || !!contract.archivedAt"
          (selectionChange)="emitChangeContractStatus(contract, $event)"
          (click)="$event.stopPropagation()"
        ></app-contract-status-select>
        <div tiimeListItemActions>
          @if (contract.salesRepresentativeUser) {
            <app-business-user-slug
              [businessUserAcronym]="contract.salesRepresentativeUser?.acronym"
              [tiimeTooltip]="contract.salesRepresentativeUser?.fullName"
            ></app-business-user-slug>
          }
        </div>
      </tiime-list-item>
    }
  </tiime-list>

  @if (contracts()?.length === 0) {
    <span class="empty-state">{{ emptyLabel() }}</span>
  }

  @if (canCreateContract()) {
    <button tiime-button color="primary" (click)="emitCreateContract()">
      <mat-icon fontSet="fontastic" fontIcon="icon-ic-add-1"></mat-icon>
      Ajouter un contrat
    </button>
  }
</div>
